<div class="content-layout">
  @if (ready) {
    <brightside-web-display-campaign
      [campaign]='campaign'
      [analyticsAttributes]="{ event_name: 'credit_intro_shown' }"
      (campaignEvent)='handleCampaignEvent($event)'
      [showBackArrow]='true'></brightside-web-display-campaign>
  }
</div>

<bw-modal-legacy *ngIf="showFatalError" modalWidth="medium" [showCloseButton]="false" (closeModal)="showFatalError = false"
    [brightsideWebFb]="{ event_name: 'error_shown', custom: { 'error id': 'credit_setup_general' }}" [error_view]="true">
  <typography-legacy title-medium color="var(--primary-text)" class="mb-sm">{{ 'ERROR_TITLE_GENERAL' | translate }}</typography-legacy>
  <section class="body">
    <bw-paragraph-legacy>
      <typography-legacy text-large-regular color="var(--secondary-text)">
        <p class="mb-xs">
           {{ 'ERROR_IDENTITY_FAILED' | translate:{phone: supportNumber | phone } }}
        </p>
      </typography-legacy>
    </bw-paragraph-legacy>
  </section>
  <footer class="footer">
    <div class="flex-row row-reverse">
      <button
        bw-button-legacy
        [brightsideWebFb]="{ event_name: 'credit_intro_tapped', action: 'click' }"
        (click)="handleFatalErrorCtaClick()">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>
  </footer>
</bw-modal-legacy>
